module.exports = __webpack_public_path__ + "img/Carina Nebula Splash Screen Mobile Close.836e1556.png";